export default __webpack_public_path__ + "2f76038a849de1b63ddabe69efd18964.png";